import { accessibleModuleGuides } from "app/help/moduleGuides";

export function welcomeModules(auth) {
  return accessibleModuleGuides(auth).map((guide) => ({
    ...guide,
    area: guide.category.split(" / ")[0],
  }));
}
const searchable = (value) =>
  String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
export function findWelcomeModules(modules, query, area) {
  const words = searchable(query).trim().split(/\s+/).filter(Boolean);
  return modules.filter(
    (module) =>
      (!area || module.area === area) &&
      words.every((word) =>
        searchable(`${module.title} ${module.category} ${module.purpose}`).includes(word)
      )
  );
}
export function welcomeName(user) {
  const username = user?.user?.username || user?.username || "";
  const name = username.trim().split(/[.\s_-]+/)[0];
  return name ? name.charAt(0).toLocaleUpperCase("es") + name.slice(1) : "";
}
